import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { PricingStrategy } from 'quotes/enums';
import { IQuotePart } from 'quotes/types';
import { getPricingStrategyLabels } from 'quotes/utils';

export const PricingStrategyCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.PRICING_STRATEGY);

  if (!data) {
    return props?.value && getPricingStrategyLabels()[props.value as PricingStrategy];
  }

  const { pricingStrategy } = data as IQuotePart;

  if (!pricingStrategy) {
    return DEFAULT_PLACEHOLDER;
  }

  return getPricingStrategyLabels()[pricingStrategy] ?? DEFAULT_PLACEHOLDER;
};
